import dot from 'dot-object';
import { propHasValue } from '../../components/DynamicFormNew/helper';
import { deepFind } from '../../helpers/deepFind';
import { _checkValue } from '../../helpers/form';

export const inputTypes = {
  MODAL: 'modal',
};

export const isGroupInput = (group, repeatable = false) => {
  return group.inputs
    && Object.keys(group.inputs).length
    && group.repeatable === repeatable
    && group.display !== 'group'
    && !group.viewGroup
    && !group.component;
}

export const repeatObjects = (obj, fn = () => { }, filter = null) => filter ?
  Object.keys(obj).filter((key) => filter(obj[key])).map(fn) : Object.keys(obj).map(fn);

export const getRepeatObjects = (obj, fn = () => { }, filter = null) => filter ?
  Object.keys(obj).filter((key) => filter(obj[key])) : Object.keys(obj);

export const conditions = new RegExp(/( is | and | not | notEmpty | includes )/gm);

export const getLastRow = (arr, cols) => {
  let currentInd = -1;
  const newArr = [];
  arr.forEach(nr => {
    if (nr % cols === 0) {
      newArr[currentInd + 1] = [nr];
      currentInd++;
    } else {
      newArr[currentInd].push(nr);
    }
  });
  return newArr[newArr.length - 1];
}
const _verifyCondition = (condition, data, allData) => {
  let [path, match, needed] = condition.split(conditions);
  const isRepeatable = path.split('./').length > 1;
  path = isRepeatable ? path.split('./')[1] : path;
  match = match ? match.trim() : match;
  if (path) {
    const currentValue = dot.pick(path, isRepeatable ? data : (allData || data));
    if (match === 'notEmpty') {
      return propHasValue(currentValue)
        && currentValue !== '';
    }
    return _checkValue(needed, match, currentValue);
  }
  return false;
}
export const verifyConditional = (condition, data, allData) => {
  if (!condition) {
    return true;
  }
  const isOrCond = condition.indexOf('OR') >= 0;
  const allParts = condition.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
  const parts = allParts.map(cond => _verifyCondition(cond, data, allData));
  return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
}
const checkCondition = (condition, formsValue, repeatValues, input) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty )/gmi);
  match = match ? match.trim() : null;
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  if (match && field.split('.').length > 1) {
    if (input.inputs) {
      const value = deepFind(formValue, field);
      const isShown = _checkValue(
        isNotEmpty ? field : wantedValue,
        match,
        isNotEmpty ? formValue : value
      );
      return isShown;
    } else {
      if ((isRepeatable ? !repeatValues : !formsValue)) {
        return false;
      } else {
        const value = deepFind(formValue, field);
        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        return isShown;
      }
    }
  } else {
    const value = deepFind(formValue, field);
    const isShown = _checkValue(
      isNotEmpty ? field : wantedValue,
      match,
      isNotEmpty ? formValue : value
    );
    return isShown;
  }
}

export const showHideInput = (input, formsValue, repeatValues) => {
  if (input.showIf && !input.excludeFromView && !['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType)) {
    const isOrCond = input.showIf.indexOf('OR') >= 0;
    const allParts = input.showIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
  }
  if (typeof input.excludeFromView === 'string') {
    const isOrCond = input.excludeFromView.indexOf('OR') >= 0;
    const allParts = input.excludeFromView.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    const excludeFromView = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    return !excludeFromView
  }
  if (input.excludeFromView || ['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType)) {
    return false;
  }
  return true;
}

export const filterInputs = (form, data, repeatValues) => {
  Object.keys(form)
}

export const groupSubsections = (form, onlyConf = false) => {
  return Object.keys(form).reduce((f, fKey) => {
    if (form[fKey].subSection) {
      let subName = form[fKey].subSection;
      if (typeof form[fKey].subSection === "object") {
        subName = form[fKey].subSection.name;
      }
      if (!f[subName]) {
        f[subName] = { label: '', icon: '', position: 0 };
        if (typeof form[fKey].subSection === "object") {
          const { label = '', icon = '', position = 0 } = form[fKey].subSection;
          f[subName] = { label, icon, position };
        }
      }
      if (!onlyConf) {
        Object.assign(f[subName], { [fKey]: form[fKey] });
      }
    }
    return f;
  }, {})
}

export const getRiskGradient = (score) => {
  switch (score) {
    case 4:
      return '0:#ffffff 0.00001:#73D13D 0.5:#FA8C16 1:#FF4D4F';
    case 3:
      return '0:#ffffff 0.00001:#73D13D 0.5:#FADB14 1:#FA8C16';
    case 2:
      return '0:#ffffff 0.00001:#73D13D 1:#FADB14';
    case 1:
      return '0:#ffffff 0.00001:#73D13D 1:#73D13D';
    case 0:
      return '0:#ffffff 0.00001:#73D13D 1:#ffffff'
    default:
      return '0:#ffffff 0.00001:#73D13D 0.5:#FA8C16 1:#CF1322';
  }
}
